// extracted by mini-css-extract-plugin
module.exports =  {"bpTablet":"1635px","bpNoResize":"960px","bpPhone":"887px","bpPhoneLandscape":"475px"};